import { createApp } from 'vue'
import { Lazyload } from 'vant'
import App from './App.vue'

createApp(App).use(Lazyload).mount('#app')
